
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  article: ArticleData;
}

interface Data {
  title: string | null;
}

interface Methods {
  setFontSize: () => void;
  toggleReportModal: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
    };
  },
  methods: {
    setFontSize() {
      this.$emit('set-font-size');
    },
    toggleReportModal() {
      this.$store.commit('article/toggleMistakeReport');
      return true;
    },
  },
});
